<template>
    <div class="h-100 d-flex flex-column overflow-auto">
        <VendorList/>
    </div>
</template>

<script>
import VendorList from "@/components/vendors/pages/VendorList.vue";

export default {
    name: 'VendorListApp',
    components: {
        VendorList,
    },
    mixins: [],
    props: {},
    data() {
        return {
            
        }
    },
    computed: {
        
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
}
</script>

<style lang="scss" scoped>
</style>